import React from "react";

const ResetTitle = () => {
  return (
    <div className="reset-title">
      <h2>정보 수정하기</h2>
    </div>
  );
};

export default ResetTitle;
